import { Box, MenuItem } from "@mui/material";
import Select from "@mui/material/Select";
import React, { useEffect, useState } from "react";
import Notification from "./Notification";
import Notificationicon from "../assets/svg/notifications.svg";
import help from "../assets/svg/help.svg";
import { useSelector } from "react-redux";

const filterRequiredPages=[
  'Packages','Single Shipping','Consolidated Shipping','Shoppings','Express Request','Shipping Complete','No Suites Packages','Abandoned'
]

function PageHeader({
  pageTitle,
  selectedFilters,
  filterOptions,
  changeFilterHandler,
}) {
  const user = useSelector((state) => state.auth.value);
  const [notificationDrawerOpen, setNotificationDrawerOpen] = useState(false);

  const toggleNotification = () => {
    setNotificationDrawerOpen(!notificationDrawerOpen);
  };
  console.log(filterOptions, "filterOptions");
  return (
    <Box sx={{ height: "57px" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box className="flex items-center justify-center">
          <label
            className="me-2"
            style={{
              textAlign: "left",
              fontSize: " 26px",
              fontWeight: "bold",
            }}
          >
            {pageTitle}
          </label>
          {filterRequiredPages.includes(pageTitle)&&<Box>
            {user?.role === "Superadmin"&&
            <>
              <label htmlFor="">Forwarder{" "}</label>
              <Select
              id="demo-simple-select"
              value={selectedFilters?.routePartnerId||""}
              onChange={(e) => {
                changeFilterHandler({
                  routePartnerId: e.target.value,
                  warehouseId: "",
                });
              }}
              placeholder="Select Forwarder"
              sx={{
                m: 1,
                minWidth: 270,
                minHeight: "8px",
                marginLeft: "0px",
              }}
              style={{ height: "40px" }}
              // renderValue={(selected) => {
              //   console.log(selected, "selected in pageheader");
              //   if (!selected) {
              //     return <em>Select Forwarder</em>;
              //   }
              // }}
            >
              {filterOptions?.routePartners?.map((abc) => {
                return <MenuItem value={abc.id}>{abc?.name}</MenuItem>;
              })}
            </Select>
            </>
            }
            <>
            <label htmlFor="">Warehouse{" "}</label>
            <Select
              id="demo-simple-select"
              value={selectedFilters?.warehouseId||""}
              onChange={(e) => {
                changeFilterHandler({
                  warehouseId: e.target.value,
                });
              }}
              placeholder="Select Warehouse"
              sx={{
                m: 1,
                minWidth: 270,
                minHeight: "8px",
                marginLeft: "0px",
              }}
              style={{ height: "40px" }}
            >
              {filterOptions?.warehouses?.map((abc) => {
                return <MenuItem value={abc.id}>{abc?.warehouseName}</MenuItem>;
              })}
            </Select>
            </>
            
          </Box>}
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          <Box
            sx={{ marginRight: "20px", cursor: "pointer" }}
            onClick={toggleNotification}
          >
            <img src={Notificationicon} alt="notification_icon" />
          </Box>
          <Notification
            open={notificationDrawerOpen}
            onClose={toggleNotification}
          />
          <Box>
            <img src={help} alt="help_icon" />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default PageHeader;
